import { render, staticRenderFns } from "./TechnologistOrderForm.vue?vue&type=template&id=58c22da8&scoped=true"
import script from "./TechnologistOrderForm.vue?vue&type=script&lang=ts"
export * from "./TechnologistOrderForm.vue?vue&type=script&lang=ts"
import style0 from "./TechnologistOrderForm.vue?vue&type=style&index=0&id=58c22da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c22da8",
  null
  
)

export default component.exports